import { render, staticRenderFns } from "./WholesaleOrders.vue?vue&type=template&id=354433c5&scoped=true&"
import script from "./WholesaleOrders.vue?vue&type=script&lang=js&"
export * from "./WholesaleOrders.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleOrders.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WholesaleOrders.vue?vue&type=style&index=1&id=354433c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354433c5",
  null
  
)

export default component.exports